import { render, staticRenderFns } from "./tariffsLeisure.vue?vue&type=template&id=355c1e9a&scoped=true"
import script from "./tariffsLeisure.vue?vue&type=script&lang=js"
export * from "./tariffsLeisure.vue?vue&type=script&lang=js"
import style0 from "./tariffsLeisure.vue?vue&type=style&index=0&id=355c1e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355c1e9a",
  null
  
)

export default component.exports